import { createReducer } from '../utils'

export const DATA = 'sherrinford/sidebar/DATA'

const initialStates = {
  data: {
    opened: false,
    bodyClass: 'page-header-fixed page-sidebar-closed-hide-logo page-content-white',
    ulClass: 'page-sidebar-menu page-header-fixed',
  },
}

export default createReducer(initialStates, {
  [DATA]: (state, data) => ({
    ...state,
    data,
  }),
})

export const setData = data => ({
  type: [DATA],
  payload: data,
})
